import { useEffect, useMemo, useState } from 'react';

export interface UseRotatingPromptHintOptions {
  phrases: readonly string[];
  typingMs?: number;
  erasingMs?: number;
  pauseMs?: number;
}

export function useRotatingPromptHint({
  phrases,
  typingMs = 100,
  erasingMs = 50,
  pauseMs = 2000,
}: UseRotatingPromptHintOptions): string {
  const stablePhrases = useMemo(() => phrases, [phrases]);
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [text, setText] = useState('');
  const [typing, setTyping] = useState(true);

  useEffect(() => {
    const currentPhrase = stablePhrases[phraseIndex] ?? '';
    if (typing) {
      if (text.length < currentPhrase.length) {
        const timeout = window.setTimeout(() => {
          setText(currentPhrase.slice(0, text.length + 1));
        }, typingMs);
        return () => window.clearTimeout(timeout);
      }
      const timeout = window.setTimeout(() => setTyping(false), pauseMs);
      return () => window.clearTimeout(timeout);
    }
    if (text.length > 0) {
      const timeout = window.setTimeout(() => {
        setText(text.slice(0, -1));
      }, erasingMs);
      return () => window.clearTimeout(timeout);
    }
    setPhraseIndex((prev) => (prev + 1) % stablePhrases.length);
    setTyping(true);
    return undefined;
  }, [text, phraseIndex, typing, stablePhrases, typingMs, erasingMs, pauseMs]);

  return text;
}
